/**
 * useEingangPolicenkontrolle - the Policenkontrolle-Befund(e) of the police(s) an Eingang produced
 * (P2 hardening 05, the Systemanalyse pane). live -> GET /posteingang/:commId/policenkontrolle; mock ->
 * the Policenkopien-Helvetia fixture. A broker without placement.read (403) or an Eingang with no
 * controlled police (404/empty) simply gets no pane - never an error.
 */
import { useQuery } from '@tanstack/react-query';
import type { PosteingangPolicenkontrolleResponse } from '@brokly/shared';
import { apiClient, ApiError } from '../../../lib/api-client';
import { isLiveData } from '../../../lib/data-mode';
import { qk } from '../../../lib/query-keys';
import { posteingangPolicenkontrolleMock } from '../mock';

const EMPTY: PosteingangPolicenkontrolleResponse = { data: [] };

export function useEingangPolicenkontrolle(commId: string | null, enabled = true) {
  const live = isLiveData();
  return useQuery<PosteingangPolicenkontrolleResponse>({
    queryKey: qk.posteingangPolicenkontrolle(commId ?? 'none', live ? 'live' : 'mock'),
    queryFn: async () => {
      if (!live) return { data: posteingangPolicenkontrolleMock(commId as string) };
      try {
        return await apiClient.posteingang.policenkontrolle(commId as string);
      } catch (err) {
        // No Ausschreibungs-Recht (403) or a hidden/absent Eingang (404) -> no pane, not an error.
        if (err instanceof ApiError && (err.status === 403 || err.status === 404)) return EMPTY;
        throw err;
      }
    },
    enabled: enabled && commId !== null,
    retry: false,
  });
}
